import { useEffect, useState } from 'react'
import axios from 'axios'
import Place from './Place'
type ContentTypes = {
  place: String,
  desc: String
  img: String,
  id: String
}
type DataType = {
  places: []
}
const PlacesContainer = () => {
  const [data, setData] = useState<DataType | null>(null)
  useEffect(() => {    
    async function getDate() {
      const response = await fetch("./db.json");
      const places = await response.json();
      setData(places)
      
      // Using npm run server
      // const response = await fetch("http://localhost:5001/db");
      // const places = await response.json();
      // setData(places)
    }
    getDate()
  }, [])

  return data ? (
    <div className="places-container">
      {data.places.map((content: ContentTypes, i) => {
        const {place, desc, img} = content
        return <Place place={place} img={img} desc={desc} key={i} />;
      })}
    </div>
  ) : (
    <div className="error-container">Failed to load data places</div>
  );
}

export default PlacesContainer